import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { filter, map, shareReplay, tap } from 'rxjs/operators';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { AccountingService } from '@app/modules/my-business/services/accounting.service';

@Component({
  selector: 'sbnb-accounting-form-tracking-categories',
  templateUrl: './accounting-form-tracking-categories.component.html',
  styles: [],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountingFormTrackingCategoriesComponent implements OnInit {
  // Dependencies
  private accountingService = inject(AccountingService);
  public form = inject(FormGroupDirective);

  // State
  public canCreateTrackingCategories$ = this.accountingService.connection$.pipe(
    filter(Boolean),
    map((connection) => connection.can_create_tracking_categories)
  );

  public formState$ = this.accountingService.formState$;

  // Get tracking category options from form state
  public trackingCategories$ = this.formState$.pipe(map((state) => state.data?.properties.options || []));

  // Get the default tracking category value for a property
  public getDefaultTrackingCategory$(propertyId: number) {
    return this.formState$.pipe(
      map((state) => {
        const fieldData = state.data?.properties.fieldMap[propertyId];
        return fieldData?.isDefault && fieldData?.value ? fieldData?.value : null;
      }),
      shareReplay(1)
    );
  }

  ngOnInit(): void {}

  selectedTrackingCategory(propertyId: number) {
    const selectedClassId = this.form.form.get(['properties', propertyId]).value;
    return this.trackingCategories$.pipe(
      map((categories) => categories.find((category) => category.id === selectedClassId))
    );
  }
}
